/* mm-aktion.js — Magic Milk
 *
 * Die Kachelreihe "Bestseller" auf der Startseite, nach Merts
 * Vorlage von morenutrition.de (15.08.2026).
 *
 * Der rote Aktionsblock, der hier bis zum 16.08. mit drin war, ist auf
 * Merts Wunsch entfallen ("raus damit").
 *
 * KEINE PREISE IM CODE, und seit 16.08. auch KEINE PREISE IM BILD —
 * Mert: "Preise müssen raus. Preise dürfen nicht angezeigt werden."
 * Der Rabatt in der Ecke bleibt; er wird weiterhin live aus
 * /collections/all/products.json gerechnet, nie fest eingetragen.
 * Auch die Prozentzahl im roten Block kommt aus den Live-Daten und wird
 * auf die nächste 5er-Stufe ABGERUNDET, damit sie nie zu viel verspricht.
 *
 * Reihenfolge (Mert, 16.08.): erst die vier Einzelsorten — Standard,
 * Strawberry, Magic Fruit, Nuss & Creamy — danach die Sets, danach der Rest.
 *
 * Der Weiterlauf ist bewusst KEIN Karussell: die Reihe wandert alle paar
 * Sekunden um genau eine Kachel weiter, weich beschleunigt und abgebremst.
 * Endlos ohne Rücksprung, weil die Liste doppelt im Bau steht und die
 * Position nach einem Durchgang unsichtbar zurückgesetzt wird.
 */
(function () {
  if (!(typeof window.mmStartseite === 'function' ? window.mmStartseite() : window.location.pathname === '/')) return;

  var ROT = '#E5142A';
  var DUNKEL = '#151013';
  var QUELLE = '/collections/all/products.json?limit=50';
  var ANZAHL = 12;          // wie viele Kacheln in den Umlauf gehen
  /* Wie viele Kacheln gleichzeitig zu sehen sind. Muss zu den
     Breakpoints im Stilblatt weiter unten passen, denn davon haengt ab,
     welche Bilder SOFORT geladen werden - der Rest kommt per lazy nach.
     19.08.: Vorher stand hier fest 4. Seit die Reihe am Rechner 5 bis 7
     Kacheln zeigt, blieben die hinteren leer und man sah den alt-Text
     ("Kapsel System FOR X5 ..."). Darum jetzt aus der Fensterbreite
     gerechnet - Handy bleibt bei 4, also unveraendert. */
  function sichtbareKacheln() {
    var w = (window.innerWidth || 375);
    if (w >= 1500) return 7;
    if (w >= 1200) return 6;
    if (w >= 900)  return 5;
    return 4;
  }
  var SICHTBAR = sichtbareKacheln();
  var PAUSE = 2800;         // Standzeit je Kachel in Millisekunden
  var GLEITEN = 700;        // Dauer der Bewegung in Millisekunden

  // Merts Reihenfolge: diese vier zuerst, in genau dieser Folge
  var ZUERST = [
    'magic-milk-for-x5',              // Standard
    'magic-milk-for-x5-erdbeer',      // Strawberry
    'magic-fruit-strawberry',         // Magic Fruit Premium
    'zero-termo-milk-pro-milk'        // Nuss & Creamy
  ];

  /* Eigene Kachelbilder, die das Produktbild aus Shopify überschreiben.
     Mert 16.08.: das Florea-Bild soll freigestellt sein. Die Datei liegt
     im Theme und wird über die eigene Skript-Adresse gefunden, damit sie
     auch nach einem Theme-Duplikat noch stimmt.
     Wichtig: Das Produktbild in Shopify bleibt unangetastet — die
     Ersetzung gilt NUR für diese Kachelreihe. */
  var BASIS = '';
  try {
    BASIS = ((document.currentScript && document.currentScript.src) || '')
      .split('?')[0].replace(/[^/]*$/, '');
  } catch (e) {}
  /* Notnagel, falls currentScript fehlt (alte Browser, eingebettete
     Ausfuehrung): irgendein anderes mm-Skript auf der Seite liefert
     denselben Ordner. Erst danach ein fester Pfad - und der darf keine
     Theme-Nummer enthalten, sonst zeigt eine Kopie auf das falsche Theme. */
  if (!BASIS) {
    var irgend = document.querySelector('script[src*="/assets/mm-"]');
    if (irgend) BASIS = irgend.src.split('?')[0].replace(/[^/]*$/, '');
  }
  if (!BASIS) BASIS = '/cdn/shop/t/28/assets/';

  /* 19.08.2026 Mert: "diese Section statt mit Hintergrund - ueberall
     Hintergrund raus und transparenter Hintergrund Produktbilder."

     Die Shopify-Produktfotos sind SZENENBILDER: die Packung steht auf einem
     Podest zwischen Erdbeeren, Pistazien, Kaffeebohnen. Am 19.08. gemessen -
     die Randfarben streuen um 200 bis 250 Stufen, damit laesst sich Packung
     nicht von Deko trennen, ein automatisches Freistellen wuerde die Deko
     mitnehmen oder Loecher in die Packung schneiden.

     Genommen werden deshalb Merts eigene, schon freigestellte Aufnahmen aus
     ~/Desktop/Sets/Zweierset Bilder/Transparent/ (Alphakanal an allen vier
     Ecken geprueft). Sie sind auf den Inhalt beschnitten, quadratisch mit
     6 % Luft gefasst und als WebP mit Alphakanal auf 400 px gerechnet - aus
     240-320 KB PNG wurden 11-26 KB.

     Fuer Kaffee, Tee, Kapseln und die Sets gibt es KEINE freigestellte
     Fassung; die behalten ihr Szenenfoto, bis saubere Studioaufnahmen da
     sind. */
  var EIGENES_BILD = {
    /* 19.08.: Mert will die SEITENFLAECHE sehen ("mach mal das als
       Produktbild bei Bestseller"). Quelle war
       ~/Desktop/anweundung_files/seitlich Kopie.png - heller ruhiger
       Grund #E0E0DF, Streuung 6, deshalb sauber freistellbar. Geschnitten
       ueber Flutung von allen vier Raendern mit der Regel "hell UND
       farblos"; 69 % der Flaeche fielen weg, die Packung blieb ganz.
       Zurueck auf die Vorderansicht: naechste Zeile wieder aktivieren. */
    'magic-milk-for-x5':         BASIS + 'mm-frei-standard-seite.webp',
    /* 'magic-milk-for-x5':      BASIS + 'mm-frei-standard.webp', */
    'magic-milk-for-x5-erdbeer': BASIS + 'mm-frei-strawberry.webp',
    'zero-termo-milk-pro-milk':  BASIS + 'mm-frei-nuss.webp',
    'magic-fruit-strawberry':    BASIS + 'mm-frei-florea.webp',
  /* 20.08.2026 ergaenzt - Mert: "Mach von allen ein Transparenz bei Bestseller.
     Der Hintergrund darf nicht zu sehen sein." Damit haben ALLE zwoelf Kacheln
     freigestellte Bilder, keine Szenenfotos mehr. */
  'for-x5-coffe-premium-weight-control':       BASIS + 'mm-frei-coffee.webp',
  'ananas':                                    BASIS + 'mm-frei-ananas.webp',
  'kapseln-for-x5':                            BASIS + 'mm-frei-kapsel.webp',
  /* Cherry und Lemon Tea zeigen dasselbe Bild - im Shop haben BEIDE Produkte
     nur die eine Datei tea-iron-slim-1.png hinterlegt. Lemon braucht ein eigenes. */
  'for-x5-coffe-weight-control-kopie':         BASIS + 'mm-frei-teairon.webp',
  'cherry-tea-iron-slim-weight-control-kopie': BASIS + 'mm-frei-teairon.webp',
  /* Die drei 2er-Sets sind aus den eigenen freigestellten Einzelpackungen
     zusammengesetzt - zwei Packungen, wie es ein 2er-Set auch ist. Die alten
     Fotos waren ein Flatlay-Muster bzw. eine einzelne Packung. */
  'magic-milk-for-x5-strawberry-2er-set':      BASIS + 'mm-frei-set2-strawberry.webp',
  'magic-milk-for-x5-strawberry-2er-set-kopie':BASIS + 'mm-frei-set2-gemischt.webp',
/* 21.08.2026, Mert: "2er set ueberall anpassen auch beim produkt selbst",
     dazu "2er standard". Das Motiv hat eingebauten Text (MAGIC MILK) -
     es laeuft ueberall auf contain und ist 1:1, also wird nirgends etwas
     beschnitten (feste Regel). */
  '2er-packung-rabatt':                        'https://cdn.shopify.com/s/files/1/0958/0465/3955/files/set2-standard-motiv.png'
  };

  var ruhig = false;
  try { ruhig = matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) {}

  var css = [
    /* mm-bewegung.js zerlegt jede Überschrift in #MainContent in einzelne
       Buchstaben (span.mmZ, display:inline-block). Zwischen inline-block
       darf immer umbrochen werden, auch mitten im Wort — daran zerfiel
       "ALLES" zu "A LLES". Hier auf display:inline zurückholen. */
    'html body #mmAktion h2 .mmZ,html body #mmAktion h2 .mmTeil,',
    'html body #mmAktion h2 .mmTA,html body #mmHigh h2 .mmZ,',
    'html body #mmHigh h2 .mmTeil,html body #mmHigh h2 .mmTA{',
    'display:inline!important;opacity:1!important;transform:none!important;',
    'filter:none!important;animation:none!important;white-space:normal!important;',
    'font-size:inherit!important;font-weight:inherit!important}',

    /* ---------- Kachelreihe ---------- */
    '#mmHigh{flex:none!important;width:100%;max-width:100%;box-sizing:border-box;',
    'background:#fff;color:' + DUNKEL + ';margin:0;padding:14px 0 clamp(24px,4vw,40px)}',
    '#mmHigh *{box-sizing:border-box}',
    '#mmHigh h2{font-family:"Barlow Condensed",sans-serif;font-weight:800;',
    'text-transform:uppercase;font-size:clamp(26px,4.6vw,40px);line-height:1.1;',
    'text-align:center;margin:0 0 16px;padding:0 20px;color:' + DUNKEL + ';',
    'overflow-wrap:normal!important;word-break:keep-all!important}',

    /* Laufband: vier sichtbar, waagerecht, Rollbalken versteckt.
       Kein scroll-snap — die Position wird per Skript gesetzt, Snap
       würde dagegen arbeiten. */
    '#mmHigh .mmHiFenster{overflow:hidden;padding:2px 12px 4px}',
    '#mmHigh .mmHiReihe{display:flex;gap:8px;overflow-x:auto;',
    'scrollbar-width:none;-ms-overflow-style:none;scroll-behavior:auto;',
    '-webkit-overflow-scrolling:touch}',
    '#mmHigh .mmHiReihe::-webkit-scrollbar{display:none;width:0;height:0}',
    '#mmHigh .mmHiKarte{flex:0 0 calc((100% - 24px)/4);min-width:0;',
    'background:#F4F1F2;border-radius:18px;padding:6px 6px 10px;',
    'text-decoration:none;color:inherit;display:flex;flex-direction:column;gap:4px;',
    'border:1px solid rgba(21,16,19,.06)}',
    '#mmHigh .mmHiKarte:hover{background:#EDE8EA}',
    /* Rabatt-Aufkleber - zwei Korrekturen von Mert am 21.08.2026:
       1. "bis zum ende lang ziehen nicht so kurz halten" -> war eine kurze
          Pille, wurde volle Breite.
       2. "zu gross nimmt viel platz bisschen kleiner kreativer moderner"
          -> die volle Breite war zu wuchtig UND kostete eine eigene Zeile.
       Loesung: der Aufkleber liegt jetzt IM Bild, oben links, und ist damit
       aus dem Textfluss raus - er kostet keine Hoehe mehr. Dunkles Glas
       statt rosa Flaeche, damit er auf jedem Produktbild sitzt. */
    '#mmHigh .mmHiKarte{position:relative}',
    '#mmHigh .mmHiRab{position:absolute;top:7px;left:7px;z-index:2;',
    'background:rgba(21,16,19,.82);color:#fff;',
    '-webkit-backdrop-filter:blur(6px);backdrop-filter:blur(6px);',
    'font-weight:700;font-size:10px;letter-spacing:.02em;',
    'padding:3px 7px;border-radius:999px;line-height:1.25;',
    'white-space:nowrap;pointer-events:none}',
    '#mmHigh .mmHiBild{width:100%;aspect-ratio:1/1;object-fit:contain;',
    'display:block;background:transparent;border-radius:12px}',

    /* Titel fett (Mert, 16.08.), zwei Zeilen, danach abgeschnitten */
    '#mmHigh .mmHiName{font-size:11px;line-height:1.3;margin-top:2px;',
    'font-weight:700;display:-webkit-box;-webkit-line-clamp:2;',
    '-webkit-box-orient:vertical;overflow:hidden;hyphens:auto}',

    /* Am Rechner kleinere Kacheln, dafuer mehr davon zu sehen
       (Mert, 19.08.: "auf pc muss das kleiner sein (mehr auswahl)").
       Es liegen 24 Produkte in der Reihe - bei vier sichtbaren sah man
       ein Sechstel. Handy bleibt unberuehrt, wie abgesprochen.
       Die Zahl in /5, /6, /7 ist die Menge sichtbarer Kacheln, der
       Abzug davor ist (Anzahl-1) * Abstand. */
    '@media(min-width:900px){',
    '#mmHigh .mmHiFenster{padding:2px 20px 8px;max-width:1400px;margin:0 auto}',
    '#mmHigh .mmHiReihe{gap:14px}',
    '#mmHigh .mmHiKarte{flex:0 0 calc((100% - 56px)/5);padding:8px 8px 12px;gap:5px;border-radius:18px}',
    '#mmHigh .mmHiRab{font-size:11px;padding:4px 9px;top:9px;left:9px}',
    '#mmHigh .mmHiName{font-size:13px;line-height:1.3}}',
    '@media(min-width:1200px){',
    '#mmHigh .mmHiReihe{gap:14px}',
    '#mmHigh .mmHiKarte{flex:0 0 calc((100% - 70px)/6)}}',
    '@media(min-width:1500px){',
    '#mmHigh .mmHiKarte{flex:0 0 calc((100% - 84px)/7)}}'
  ].join('');

  function stil() {
    if (document.getElementById('mmHigh-stil')) return;
    var s = document.createElement('style');
    s.id = 'mmHigh-stil';
    s.textContent = css;
    (document.head || document.documentElement).appendChild(s);
  }

  /* Produktnamen für die schmalen Kacheln kürzen. Gegen alle 19 Produkte
     geprüft, längster Kurzname 20 Zeichen. Der volle Titel bleibt im
     alt-Text des Bildes erhalten. */
  function kurz(titel) {
    var t = titel;
    t = t.replace(/\s*[-–]?\s*Slim Weight Control\s*$/i, '');
    var set = t.match(/^\((\d)er SET\)\s*(.*)$/i);
    if (set) {
      var rest = set[2].replace(/\s*[-–]?\s*FOR X5\s*$/i, '')
        .replace(/Magic Milk FOR X5/i, '').replace(/^\s*[-–]\s*/, '').trim();
      if (/^Standard\s*&\s*Strawberry$/i.test(rest)) rest = 'Gemischt';
      return set[1] + 'er Set · ' + (rest || 'Standard');
    }
    t = t.replace(/Magic Fruit Premium\s*[-–]\s*Strawberry/i, 'Magic Fruit');
    t = t.replace(/Pro Milk ZeroTermo\s*\(Premium\)\s*[-–]\s*/i, '');
    t = t.replace(/Magic Milk FOR X5\s*[-–]\s*/i, '');
    t = t.replace(/^Magic Milk FOR X5$/i, 'Standard');
    t = t.replace(/Kapsel System FOR X5/i, 'Kapsel System');
    t = t.replace(/Coffee FOR X5\s*\(Standard\)/i, 'Coffee Standard');
    t = t.replace(/Coffee PLUS FOR X5\s*\(Premium\)/i, 'Coffee PLUS');
    t = t.replace(/Magic Coffee\s*\(Special\)/i, 'Magic Coffee');
    t = t.replace(/\s*\(Premium\)\s*/i, ' ');
    t = t.replace(/\s*FOR X5\s*/i, ' ');
    return t.replace(/\s{2,}/g, ' ').trim();
  }

  function ankerSuchen() {
    var kreis = document.querySelector('.st_story-circle');
    if (kreis) {
      var storySekt = kreis.closest('.shopify-section');
      if (storySekt && storySekt.offsetHeight > 40) return storySekt;
    }
    var haupt = document.getElementById('MainContent');
    if (!haupt) return null;
    var sekt = [].slice.call(haupt.children).filter(function (s) {
      return s.classList && s.classList.contains('shopify-section') && s.offsetHeight > 60;
    });
    return sekt.length >= 2 ? sekt[0] : null;
  }

  /* ------------------------------------------------------------------ */
  /* Weiterlauf: eine Kachel weiter, weich, endlos                       */
  /* ------------------------------------------------------------------ */

  function laufband(reihe, anzahl) {
    if (ruhig) return;                       // Nutzer will keine Bewegung
    var laeuft = false, angehalten = false, uhr = null;
    /* Position wird als ZÄHLER geführt und daraus absolut gerechnet.
       Vorher wurde je Schritt addiert — dabei summieren sich Rundungs-
       fehler auf, und die Kacheln standen nicht mehr bündig zum Rand
       (Mert 16.08.: "Abstand an den Seiten nicht gleichmässig"). */
    var stelle = 0;
    /* Laufnummer je Gleitvorgang. Legt der Nutzer die Hand drauf, wird
       hochgezählt — der laufende Vorgang erkennt daran, dass er nicht
       mehr der aktuelle ist, und bricht ab. Ohne das schieben Skript und
       Finger gleichzeitig und es ruckelt. */
    var laufNr = 0;

    function schrittweite() {
      var a = reihe.children[0], b = reihe.children[1];
      if (!a) return 0;
      if (b) return b.getBoundingClientRect().left - a.getBoundingClientRect().left;
      return a.getBoundingClientRect().width;
    }

    // Weiche Beschleunigung und Abbremsung — kein lineares Ruckeln
    function kurve(t) {
      return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
    }

    function gleiten(nach) {
      var von = reihe.scrollLeft, weg = nach - von, start = null;
      var meine = ++laufNr;
      laeuft = true;
      function bild(zeit) {
        if (meine !== laufNr) { laeuft = false; return; }   // abgebrochen
        if (start === null) start = zeit;
        var f = Math.min(1, (zeit - start) / GLEITEN);
        reihe.scrollLeft = von + weg * kurve(f);
        if (f < 1) { requestAnimationFrame(bild); return; }
        laeuft = false;
        // Nach einem vollen Durchgang unsichtbar zurücksetzen: die Liste
        // steht doppelt im Bau, an dieser Stelle sieht es identisch aus.
        if (stelle >= anzahl) {
          stelle -= anzahl;
          reihe.scrollLeft = stelle * schrittweite();   // absolut, ohne Drift
        }
      }
      requestAnimationFrame(bild);
    }

    function weiter() {
      if (angehalten || laeuft || document.hidden) return;
      var s = schrittweite();
      if (s <= 0) return;
      stelle++;
      gleiten(stelle * s);
    }

    uhr = setInterval(weiter, PAUSE);

    // Anhalten, solange jemand selbst wischt oder mit der Maus draufsteht
    ['pointerdown', 'touchstart', 'mouseenter'].forEach(function (e) {
      reihe.addEventListener(e, function () {
        angehalten = true;
        laufNr++;            // laufende Bewegung sofort abbrechen
        laeuft = false;
      }, { passive: true });
    });
    // Auch reines Wischen ohne Zeigerereignis (Trackpad, Schwungscrollen)
    reihe.addEventListener('wheel', function () {
      angehalten = true; laufNr++; laeuft = false;
      clearTimeout(reihe._mmFrei);
      reihe._mmFrei = setTimeout(function () {
        var s = schrittweite();
        if (s > 0) { stelle = Math.round(reihe.scrollLeft / s); reihe.scrollLeft = stelle * s; }
        angehalten = false;
      }, 2500);
    }, { passive: true });
    ['pointerup', 'touchend', 'mouseleave'].forEach(function (e) {
      reihe.addEventListener(e, function () {
        setTimeout(function () {
          // Nach eigenem Wischen den Zähler auf die nächstgelegene
          // Kachel nachführen, sonst springt der nächste Schritt.
          var s = schrittweite();
          if (s > 0) {
            stelle = Math.round(reihe.scrollLeft / s);
            reihe.scrollLeft = stelle * s;
          }
          angehalten = false;
        }, 2500);
      }, { passive: true });
    });
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) laeuft = false;
    });
  }

  /* ------------------------------------------------------------------ */

  function bauen(artikel) {
    if (document.getElementById('mmHigh')) return true;
    var anker = ankerSuchen();
    if (!anker) return false;
    stil();



    var liste = artikel.slice(0, ANZAHL);

    function kachel(a, i) {
      return '<a class="mmHiKarte" href="/products/' + a.handle + '">' +
        '<span class="mmHiRab">−' + a.rabatt + ' %</span>' +
        '<img class="mmHiBild" src="' + a.bild + '" alt="' + a.titel.replace(/"/g, '&quot;') +
          '" loading="' + (i <= SICHTBAR ? 'eager' : 'lazy') + '" decoding="async">' +
        '<span class="mmHiName">' + kurz(a.titel) + '</span>' +
        '</a>';
    }

    // Zweimal bauen — das ist die Voraussetzung für den endlosen Lauf
    var reihe = liste.map(kachel).join('') + liste.map(kachel).join('');

    var high = document.createElement('section');
    high.id = 'mmHigh';
    high.innerHTML = '<h2>Bestseller</h2>' +
      '<div class="mmHiFenster"><div class="mmHiReihe">' + reihe + '</div></div>';

    /* Die ersten Kacheln SOFORT laden - hier und nicht oben im
       Zusammenbau. Gemessen am 19.08.: ueber die Laufvariable in
       liste.map(kachel) kam nie ein eager heraus, alle 24 Bilder standen
       auf lazy. Am Rechner sieht man jetzt sechs Kacheln gleichzeitig,
       und die hinteren blieben leer - man las den alt-Text
       ("Kapsel System FOR X5 ...").

       Ehrlich gemessen, damit hier nichts Falsches steht: das Attribut
       steht anschliessend TROTZDEM auf lazy - irgendetwas ausserhalb
       dieser Datei schreibt es bei allen Bildern um (nicht das Theme,
       header-menu.js und product-card.js fassen unsere Bilder nicht an;
       vermutlich eine der Geschwindigkeits-Apps). Was hier wirkt, ist
       ein anderer Weg: high haengt noch NICHT in der Seite, das Setzen
       von src auf ein losgeloestes img startet in Chrome sofort den
       Abruf. Damit sind die Bilder unterwegs, bevor das Umschreiben
       greift. Nachgemessen am 19.08.: vorher 8 von 24 Bildern da und
       vier sichtbare Kacheln leer, jetzt 24 von 24.
       Eine Kachel Reserve, damit beim ersten Wischen nichts nachlaedt. */
    var sofort = sichtbareKacheln() + 1;
    [].forEach.call(high.querySelectorAll('.mmHiBild'), function (bild, n) {
      bild.setAttribute('loading', n < sofort ? 'eager' : 'lazy');
      if (n === 0) bild.setAttribute('fetchpriority', 'high');
    });

    /* Story-Kreise bleiben die erste Reihe unter der Navigation.
       Danach: Reiter-Auswahl, dann die Kachelreihe.
       Der rote Aktionsblock ist am 16.08. auf Merts Wunsch entfallen. */
    anker.parentNode.insertBefore(high, anker.nextSibling);

    var r = high.querySelector('.mmHiReihe');
    setTimeout(function () { laufband(r, liste.length); }, 900);
    return true;
  }

  /* Die Überschrift heisst seit 16.08. "Bestseller" (Mert). Damit sie
     stimmt, entscheidet ab jetzt die echte Shopify-Kollektion
     "Bestseller" über die Reihenfolge — nach Merts vier Festgesetzten.
     Eine Liste im Code wäre in vier Wochen falsch. */
  function bestsellerHandles() {
    return fetch('/collections/bestseller/products.json?limit=30', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) {
        var m = {};
        ((j && j.products) || []).forEach(function (p) { m[p.handle] = true; });
        return m;
      })
      .catch(function () { return {}; });
  }

  function holen(top) {
    return fetch(QUELLE, { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) {
        if (!j || !j.products) return [];
        var alle = j.products.map(function (p) {
          var v = (p.variants || [])[0] || {};
          var preis = parseFloat(v.price || 0);
          var uvp = parseFloat(v.compare_at_price || 0);
          var bild = (p.images || [])[0];
          return {
            titel: p.title,
            handle: p.handle,
            bild: EIGENES_BILD[p.handle] ||
                  (bild ? bild.src.replace(/(\.[a-z]+)(\?|$)/i, '_400x$1$2') : ''),
            rabatt: uvp > preis && preis > 0 ? Math.round((1 - preis / uvp) * 100) : 0
          };
        }).filter(function (a) {
          if (!(a.rabatt > 0 && a.bild)) return false;
          /* Mert 16.08.: "zu bestseller gehören nicht sets rein ab 3er set".
             2er-Sets bleiben — die stehen auch in seiner Bestseller-
             Kollektion. Ab dem 3er raus. */
          if (/\([3-9]er SET\)/i.test(a.titel)) return false;
          return true;
        });

        // Merts Reihenfolge: erst die vier Einzelsorten, dann Sets, dann Rest
        function rang(a) {
          var i = ZUERST.indexOf(a.handle);
          if (i >= 0) return [0, i];                    // Merts vier zuerst
          if (top && top[a.handle]) return [1, -a.rabatt];  // dann echte Bestseller
          if (/\(\der SET\)/i.test(a.titel)) return [2, -a.rabatt];
          return [3, -a.rabatt];
        }
        return alle.sort(function (a, b) {
          var ra = rang(a), rb = rang(b);
          return ra[0] - rb[0] || ra[1] - rb[1];
        });
      })
      .catch(function () { return []; });
  }

  function start() {
    bestsellerHandles().then(holen).then(function (artikel) {
      if (!artikel.length) return;
      if (bauen(artikel)) return;
      var n = 0;
      var t = setInterval(function () {
        n++;
        if (bauen(artikel) || n > 12) clearInterval(t);
      }, 700);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
